import { render, staticRenderFns } from "./CellEndereco.vue?vue&type=template&id=4b3db124&scoped=true"
import script from "./CellEndereco.vue?vue&type=script&lang=js"
export * from "./CellEndereco.vue?vue&type=script&lang=js"
import style0 from "./CellEndereco.vue?vue&type=style&index=0&id=4b3db124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3db124",
  null
  
)

export default component.exports